/* eslint-disable no-param-reassign */
import { action, computed, thunk } from 'easy-peasy';
import { get } from 'lodash/fp';
import { fetchPantry } from '../../services/fbm-api';
import history from '../../history';
import { guestDashboard } from '../../paths';

export default {
  data: null,
  loading: false,
  error: null,
  isExpiredTokenError: computed(
    ({ error }) => get('message', error) === 'Expired token'
  ),
  fetch: thunk(async (actions, pantryPath, { getStoreActions }) => {
    try {
      actions.setLoading(true);
      const response = await fetchPantry(pantryPath);
      actions.set(response);
    } catch (error) {
      const { message } = error;
      actions.setError(error);
      getStoreActions().notifications.showError({ message });
      if (error.code === 404) {
        history.push(guestDashboard);
      }
    } finally {
      actions.setLoading(false);
    }
  }),
  set: action((state, response) => {
    state.data = response;
  }),
  setError: action((state, error) => {
    state.error = error;
  }),
  clear: action(state => {
    state.data = null;
  }),
  setLoading: action((state, loading) => {
    state.loading = loading;
  })
};
